import { get } from "lodash";
import { all, put, select, takeLatest } from "redux-saga/effects";
import history from "~/history";
import { routerByPartnerId } from "~/utils/func";
import { client } from "~/utils/medproSDK";
import { SET_FILTER_CHECK_DATA } from "../totalData/types";
import * as types from "./types";
import * as totalTypes from "../totalData/types";
import { openToast } from "~/components/common/molecules/ToastNotification";
import * as totalAction from "../totalData/actions";
import { huyi } from "~/utils/clog";

function* requestGetNextStep({ payload }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const { plattform, typeNext } = payload;
    const total = yield select(state => state.totalData);
    const patient = yield select(state => state.patient);
    const partnerid = get(total, "partnerId");

    let postNext;
    if (typeNext === "vacxin") {
      postNext = {
        sessionId: payload.id,
        sessionData: payload.sessionData
      };
    } else {
      const objCheckFilter = {
        treeId: total.treeId,
        stepId: "CheckBHYT",
        serviceId: total.service.id,
        template: "INSURANCE",
        hasInsurance: true,
        isValid: true
      };

      const response1 = yield client.checkFilter(objCheckFilter, {
        partnerid,
        platform
      });
      const { data } = response1;

      // ----------> app
      postNext = {
        sessionId: plattform === "app" ? payload.id : data.id || "",
        sessionData: {
          ...payload,
          insuranceCode: patient.selectedPatient.insuranceCode,
          hasInsuranceCode:
            total.service.serviceType === total.service.serviceTypeDefault
        }
      };
    }
    const response = yield client.getNextStep(postNext, {
      partnerid,
      platform
    });
    if (response) {
      yield put({
        type: SET_FILTER_CHECK_DATA,
        id: response.data.id
      });

      const { origin, pathname } = window.location;
      if (plattform === "app") {
        // app thì đổi url
        if (!pathname.includes("confirm")) {
          const index = pathname.indexOf("-app");
          const webUrl = `${pathname.slice(
            0,
            index + 4
          )}-confirm${pathname.slice(index + 4)}`;
          const url = `${origin}${webUrl}`;
          window.location.href = url;
          history.push(webUrl);
        }
      } else {
        if (plattform === "desktop") {
          const route = routerByPartnerId("/xac-nhan-thong-tin", partnerid);
          history.push(route);
        }
      }
    }
  } catch (error) {
    huyi({ name: "error-requestGetNextStep", child: error, type: 0 });
    const errorMessage = get(error, "response.data.message");
    openToast(errorMessage, "error");
  }
}

function* requestGetNextStepVacxin({ payload }) {
  const global = yield select(state => state.global);
  const platformType = get(global, "device.type");
  const platform = platformType === "desktop" ? "pc" : "web";

  const { plattform } = payload;
  const { origin, pathname } = window.location;

  // const response =
  yield client.getNextStep(
    {
      sessionId: payload.id,
      sessionData: payload.sessionData
    },
    {
      partnerid: "nhidonghcm",
      platform
    }
  );

  if (plattform === "app") {
    // app thì đổi url
    if (!pathname.includes("confirm")) {
      const index = pathname.indexOf("-app");
      const webUrl = `${pathname.slice(0, index + 4)}-confirm${pathname.slice(
        index + 4
      )}`;
      const url = `${origin}${webUrl}`;
      window.location.href = url;
      history.push(webUrl);
    }
  }
}

function* requestFilterCheck({ payload }) {
  const global = yield select(state => state.global);
  const platformType = get(global, "device.type");
  const platform = platformType === "desktop" ? "pc" : "web";

  const total = yield select(state => state.totalData);
  const partnerid = get(total, "partnerId");

  try {
    const response = yield client.getFilterByStep(
      {
        stepName: payload.type,
        stepInfo: payload
      },
      {
        partnerid,
        platform
      }
    );
    if (partnerid === "umc2") {
      let guaranteeCompanys = [];
      try {
        const responseG = yield client.getGuaranteeCompanys({
          partnerId: partnerid
        });
        guaranteeCompanys = get(responseG, "data", []);
      } catch (e) {
        guaranteeCompanys = [];
      }

      yield put({
        type: types.SET_GUARANTEE_COMPANY,
        payload: guaranteeCompanys
      });
      yield put({
        type: types.SET_FILTER_BY_STEP,
        payload: {
          ...response.data,
          pageType: "GuaranteeCompany"
        }
      });
    } else {
      yield put({
        type: types.SET_FILTER_BY_STEP,
        payload: response.data
      });
    }
  } catch (error) {
    huyi({ name: "error-requestFilterCheck", child: error, type: 0 });
    yield put({
      type: types.RESET_FILTER_BY_STEP
    });
    yield put({
      type: totalTypes.RESET_FILTER_CHECK_DATA
    });
    if (payload.callBackFn) {
      payload.callBackFn();
    } else {
      yield put(totalAction.selectService(payload));
    }
  }
}

export default function* watcher() {
  yield all([
    takeLatest(types.FILTER_GET_NEXT_STEP, requestGetNextStep),
    takeLatest(types.FILTER_GET_NEXT_STEP_VACXIN, requestGetNextStepVacxin),
    takeLatest(types.GET_FILTER_BY_STEP, requestFilterCheck)
  ]);
}
